<script>
import { getToken } from '../service/helper';

export default {
  created() {
    if (getToken()) {
      this.$router.push({ name: 'dashboard' });
    }else{
      this.$router.push({ name: 'signin' });
    }
  }
}
</script>

<template>
  <div style="background-color: #fff;">
  </div>
</template>
